import { AllergyDataModel } from "../../Model/index";

export class AllergyDataContainer {
    AllergyReports: AllergyDataModel[] = [];
    sessionExpiry: boolean;
    SessionTimeout: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/allergy/allergydatacontainer.ts